/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ContractSigningParty = typeof ContractSigningParty[keyof typeof ContractSigningParty];


export const ContractSigningParty = {
  player: 'player',
  agent: 'agent',
  club: 'club',
  counterparty: 'counterparty',
  witness: 'witness',
  other: 'other',
} as const;
